// @flow
import { Cookies } from "react-cookie";
import { all, call, fork, put, takeEvery, delay } from "redux-saga/effects";

import { fetchJSON } from "~/helpers/api";
import { getAuthToken, setToken } from "~/helpers/authUtils";

import {
  LOGIN_USER,
  LOGOUT_USER,
  REGISTER_USER,
  FORGET_PASSWORD,
  GET_ME,
  HANDLE_ERROR,
  LOGIN_USER_FAILED,
} from "./constants";

import {
  loginUserSuccess,
  registerUserSuccess,
  registerUserFailed,
  forgetPasswordSuccess,
  forgetPasswordFailed,
  setUser,
  setDesa,
  handleErrorActions,
  getMeFailed,
  logoutUser,
  setSummaryData,
  setLoading,
} from "./actions";
import { ROLES } from "~/utils";
import request from "~/utils/request";

/**
 * Login the user
 * @param {*} payload - username and password
 */
function* login({ payload: { username, password } }) {
  try {
    const response = yield call(
      request.post,
      "/v1/token/",
      {
        username,
        password,
      },
      {
        headers: {
          "Accept-Language": "id-ID",
        },
      }
    );
    setToken(response.data);
    yield put(loginUserSuccess(response.data));
  } catch (error) {
    yield put({ type: LOGIN_USER_FAILED });
  }
}

/**
 * Logout the user
 * @param {*} param0
 */
function* logout({ payload: { history } }) {
  const token = getAuthToken();
  yield put(setLoading(true));
  try {
    const response = yield call(request.post, `/v1/token/logout/`, {
      refresh: token.refresh,
    });
    if (response.status === 200) {
      setToken(null);
      window.location.replace("/user/account/login");
    }
  } catch {
    setToken(null);
    window.location.replace("/user/account/login");
  } finally {
    yield put(setLoading(false));
  }
}

/**
 * Register the user
 */
function* register({ payload: { fullname, email, password } }) {
  const options = {
    body: JSON.stringify({ fullname, email, password }),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  };

  try {
    const response = yield call(fetchJSON, "/users/register", options);
    yield put(registerUserSuccess(response));
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = error;
    }
    yield put(registerUserFailed(message));
  }
}

/**
 * forget password
 */
function* forgetPassword({ payload: { username } }) {
  const options = {
    body: JSON.stringify({ username }),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  };

  try {
    const response = yield call(fetchJSON, "/users/password-reset", options);
    yield put(forgetPasswordSuccess(response.message));
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = error;
    }
    yield put(forgetPasswordFailed(message));
  }
}

function* handleError({ payload }) {
  const cookies = new Cookies();

  cookies.remove("token");

  delay(500);

  window.location.href = payload;
}

function* getMe() {
  try {
    const response = yield call(request.get, "/v1/users/me/");

    if (
      ![
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KAURKEUANGAN,
        ROLES.KAURPERENCANAAN,
        ROLES.KADUS,
        ROLES.KAURUMUM,
      ].includes(response.data?.role)
    ) {
      // yield put(handleErrorActions("/akses-ditolak"));
    } else {
      const desa = yield call(request.get, "/v1/desa/me/");
      const summary = yield call(request.get, "/v1/sigdesa-summary");
      yield put(setUser(response.data));
      yield put(setDesa(desa.data));
      yield put(setSummaryData(summary.data.data));
    }
  } catch {
    yield put(getMeFailed());
  }
}

export function* watchLoginUser(): any {
  yield takeEvery(LOGIN_USER, login);
}

export function* watchLogoutUser(): any {
  yield takeEvery(LOGOUT_USER, logout);
}

export function* watchRegisterUser(): any {
  yield takeEvery(REGISTER_USER, register);
}

export function* watchForgetPassword(): any {
  yield takeEvery(FORGET_PASSWORD, forgetPassword);
}

export function* watchGetMe() {
  yield takeEvery(GET_ME, getMe);
}

export function* watchHandleError() {
  yield takeEvery(HANDLE_ERROR, handleError);
}

function* authSaga(): any {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchRegisterUser),
    fork(watchForgetPassword),
    fork(watchGetMe),
    fork(watchHandleError),
  ]);
}

export default authSaga;
